import * as StM from '../../models/store';
import BaseReducer from '../baseReducer';
import * as _ from 'lodash';

export default class EditUserAdminDialogReducer extends BaseReducer {
    static handle(state: StM.IEditUserAdminDialogStoreState = new StM.EditUserAdminDialogStoreState(), action: any): StM.IEditUserAdminDialogStoreState {
        switch (action.type) {
            case 'Dialogs/Admin/EditUser/Open': {
                return <StM.IEditUserAdminDialogStoreState>_.assign({}, state, {
                    isOpened: true,
                    userId: action.userId,
                    sectionType: action.sectionType
                });
            }
            case 'Dialogs/Admin/EditUser/Close': {
                return <StM.IEditUserAdminDialogStoreState>_.assign({}, state, { isOpened: false });
            }
            default: {
                return state;
            }
        }
    }
}
